var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-modal',_vm._g(_vm._b({attrs:{"toptitle":"Deal bearbeiten","title":_vm.costCenterLabel,"subtitle":_vm.updated,"name":"project-accounting-deal-edit","width":400}},'base-modal',_vm.$attrs,false),_vm.$listeners),[_c('project-accounting-deal-form',{attrs:{"projectAccountingDeal":_vm.projectAccountingDeal,"type":"edit"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }